<script>
export default {
  name: "WorkOrderTypeBadge",
  props: {
    workOrderType: {
      type: Object,
      default: () => { }
    },
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.workOrderTypeBgColor[this.workOrderType.id] ?? '#616161'
    },
  },
}
</script>

<template>
  <span
    class="badge"
    :style="{
      'background-color': this.getBackgroundColor(),
    }"
  >{{ workOrderType.work_order_type }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 0.4em 0.5em;
}
</style>
